import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useClientConstraintsQuery } from 'hooks/webapi/application/useUpsale';
import {
  useAcceptOfferMutation,
  useAcceptUpsaleMutation,
  useApplicationQuery,
  useClientOfferQuery,
} from 'hooks/webapi';
import { WAITING } from 'Router/routes';

export default function useUpsaleChangeAmount() {
  const navigate = useNavigate();

  const [amount, setAmount] = useState<number>();

  const { data: upsaleConstraintsData, isLoading: constraintsIsLoading } =
    useClientConstraintsQuery();
  const { data: application, isLoading: applicationIsLoading } =
    useApplicationQuery(true);
  const { data: offer, isLoading: offerIsLoading } = useClientOfferQuery(
    {
      amount,
      term: upsaleConstraintsData?.termInterval.defaultValue,
    },
    amount !== undefined && upsaleConstraintsData !== undefined,
  );

  const {
    mutateAsync: acceptClientUpsaleOffer,
    isPending: acceptUpsaleIsPending,
  } = useAcceptUpsaleMutation();
  const { mutateAsync: acceptOffer, isPending: acceptOfferIsPending } =
    useAcceptOfferMutation();

  // Set initial values for calculator
  useEffect(() => {
    if (!application) return;
    setAmount(application.proposal?.amount);
  }, [application]);

  const onAmountChange = useCallback(async (newAmount: number) => {
    setAmount(newAmount);
  }, []);

  const handleConfirm = async () => {
    if (!application || !amount || !upsaleConstraintsData) return;

    // This order is important
    await acceptClientUpsaleOffer({
      amount,
    });
    await acceptOffer({
      amount,
      term: upsaleConstraintsData.termInterval.defaultValue,
    });

    navigate(WAITING);
  };

  return {
    amount,
    upsaleConstraintsData,
    onAmountChange,
    handleConfirm,
    isLoading: constraintsIsLoading || applicationIsLoading || offerIsLoading,
    isPending: acceptUpsaleIsPending || acceptOfferIsPending,
    offer,
    application,
  };
}
